import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getEvent} from '../../actions';
import EventDetailsPlaceholder from './EventDetailsPlaceholder';
import EventDetails from './EventDetails';
import {withLocalize} from 'react-localize-redux';
import isEmpty from "../../../../app/utils/isEmpty";

class EventDetailsContainer extends Component {
    fetchContent() {
        let slug = this.props.match.params.slug;

        this.props.getEvent(slug);
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        const {event, loading, errors} = this.props;

        if (prevProps.languages !== this.props.languages) {
            this.fetchContent();
        }

        if (prevProps.errors !== errors && !loading) {
            if (errors.status === 303) {
                let uri = this.props.translate('routes.events_details').replace(':slug', errors.redirect);

                this.props.history.push(uri);
            }
        }

        if (!loading && isEmpty(event)) {
            if (errors.status === 422) {
                setTimeout(() => {
                    this.props.history.push('/404');
                }, 2000);
            }
        }
    }

    render() {
        const {event, loading} = this.props;

        if (event === null || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'event'
                        }}
                    >
                        <title>{process.env.REACT_APP_SITE_TITLE}</title>
                    </Helmet>
                    <div className="container">
                        <EventDetailsPlaceholder/>
                    </div>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'event'
                    }}
                >
                    <title>{(event.seo_title !== '' ? event.seo_title : event.title) + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE}</title>
                    {event.seo_meta_description !== '' &&
                        <meta name="description" content={event.seo_meta_description} />
                    }
                    {event.seo_facebook_og_title !== '' &&
                        <meta property="og:title" content={event.seo_facebook_og_title} />
                    }
                    {event.seo_facebook_og_description !== '' &&
                        <meta property="og:description" content={event.seo_facebook_og_description} />
                    }
                    {event.seo_facebook_og_image !== '' &&
                        <meta property="og:image" content={event.seo_facebook_og_image} />
                    }
                </Helmet>
                <div className="container">
                    <EventDetails event={event}/>
                </div>
            </Fragment>
        );
    }
}

EventDetailsContainer.propTypes = {
    getEvent: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    event: state.events.event,
    loading: state.events.eventLoading,
    errors: state.errors,
});

export default withRouter(connect(mapStateToProps, {getEvent})(withLocalize(EventDetailsContainer)));



// WEBPACK FOOTER //
// ./src/features/Events/components/Details/EventDetailsContainer.js